
import { utils } from 'apprise-core/utils';
import React, { FC, ReactNode } from 'react';


export const elementRole = 'apprise-role'
export const elementContainerRole = 'apprise-container'
export const elementProxyRole = 'apprise-proxy'


export const jsxutils = () => {


  const self = {

    elementsIn: (node: React.ReactNode): JSX.Element[] =>

       utils().arrayOf(node)
        // flatten arrays
        .flatMap(c => Array.isArray(c) ? c : [c])
        // flatten fragments and containers (recur on children)
        .flatMap(c =>

          self.isElementOf(React.Fragment)(c) || self.hasRole(elementContainerRole)(c) ? self.elementsIn(c.props?.children) : [c]

        )
        // flatten proxied elements (recur on proxied)
        .flatMap(c => self.hasRole(elementProxyRole)(c) ? self.elementsIn(c.type(c.props)) : [c])
        // remove empties
        .filter(f => !!f)
        // keep typed elements
        .filter(c => c.type)

    ,

    /*
    *  encapsulates a runtime check on a react node to verify it's an element of a functional component.
    *  uses type names in a dev build as a stable identity, and the type identity in production build (where names are mangled).
    *  it's curried for convenience of use in iterations:  
    *  array.filter(isElementOf(MyComponent)) 
    */
    isElementOf: (component: FC<any>) => (child: ReactNode) =>

      process.env.NODE_ENV === 'production' || !component?.name ?

        (child as any)?.type === component :

        //react-standard alternative to apprise-level proxy container roles (since January 2023)
        ((child as any)?.type?.name === component?.name || (child as any)?.type?.displayName === component?.name)

    ,

    // accepts react nodes that are elements of types "annotated" with a given property, optionally with a given value.
    // it's a weaker form of isElementOf that can recognize elements of proxy components, such as those returned by useStable().
    // it's curried for convenience of use in iterations.
    isAnnotatedWith: (prop: string, value?: any) => (child: ReactNode) => {

      const type = (child as any)?.type ?? {}

      return value ? type[prop] === value : type.hasOwnProperty(prop)

    }

    ,

    //  accepts nodes that are either elements annotated with a role (cf. isAnnotatedWith), or have a key that starts with a role.
    //  it's curried for convenience of use in iterations.
    hasRole: (role: string) => (child: ReactNode) => self.isAnnotatedWith(role)(child) || (child as any)?.key?.startsWith(role)


  }


  return self;
}


